import React, { useMemo } from 'react';
import { PointStatus, pointType } from '../../../constants/types/mypage-type';
import TextWinds from '../../../components/common/TextWinds';
import { numberWithCommas } from '../../../api/utils/format/numbers';
import { Link } from 'react-router-dom';

const DESCRIPTION_RANK_POINT_EARN = '등급별 포인트 적립';
const DESCRIPTION_ADMIN_MANUAL_DEPOSIT = '관리자 수동 지급';
const DESCRIPTION_ADMIN_MANUAL_DEDUCTION = '관리자 차감';

interface PointItemProps {
  data: pointType;
}

const PointItem = ({ data }: PointItemProps) => {
  const fontColor = data.amount < 0 ? 'text-gray7' : 'text-purple5';
  const canceledStyle =
    data.status === PointStatus.CANCELED ? 'line-through' : '';

  // 설명 파싱
  const description = useMemo(() => {
    if (data.description.includes(DESCRIPTION_RANK_POINT_EARN)) {
      return DESCRIPTION_RANK_POINT_EARN;
    } else if (data.description.includes(DESCRIPTION_ADMIN_MANUAL_DEPOSIT)) {
      return DESCRIPTION_ADMIN_MANUAL_DEPOSIT;
    } else if (data.description.includes(DESCRIPTION_ADMIN_MANUAL_DEDUCTION)) {
      return DESCRIPTION_ADMIN_MANUAL_DEDUCTION;
    } else {
      return data.description;
    }
  }, [data.description]);

  return (
    <div className="flex flex-col gap-y-1 border-b py-2">
      <div className="flex justify-between gap-y-2">
        <TextWinds type="content_body4" color="gray5">
          {data.registerAt?.toString().slice(0, 10)}
        </TextWinds>
        <div className="text-xs text-gray5">
          {data.expiryAt ? (
            <>유효기간 {data.expiryAt?.toString().slice(0, 10)} 까지</>
          ) : null}
        </div>
      </div>
      <div className={`flex justify-between ${canceledStyle}`}>
        <div className={`font-semibold ${fontColor}`}>{description}</div>

        <div className={`flex items-center gap-x-1 ${fontColor}`}>
          {numberWithCommas(data.amount)}점{' '}
        </div>
      </div>
      <div>
        {data.relatedOrderId ? (
          <Link
            to={`/mypage/purchase/detail/${data.relatedOrderId}`}
            className="text-sm text-gray7 hover:text-purple5"
          >
            구매정보 {'>'}
          </Link>
        ) : null}
      </div>
    </div>
  );
};
// 2세대 포인트 컴포넌트
// const PointItem = ({ data }: PointItemProps) => {
//   const navigate = useNavigate();
//   const isCanceled = data.status === PointStatus.CANCELED;
//   const isEarn = data.type === PointType.EARN;
//   //   const isEarn = (() => {
//   //     if (data.type === PointType.EARN) {
//   //       return true;
//   //     } else {
//   //       if (
//   //         data.usageType === PointUsageType.WITHDRAW ||
//   //         data.usageType === PointUsageType.REFUND ||
//   //         data.usageType === PointUsageType.EXPIRE
//   //       ) {
//   //         if (isCanceled) {
//   //           return true;
//   //         } else {
//   //           return false;
//   //         }
//   //       } else {
//   //         return false;
//   //       }
//   //     }
//   //   })();
//   const textColor = isEarn ? 'purple5' : 'gray9';
//   const pointSign = isEarn ? '+' : '-';
//   const pointAmount = numberWithCommas(Math.abs(Number(data.amount))) ?? 0;

//   const getUsageType = (() => {
//     switch (data.usageType) {
//       case PointUsageType.DEPOSIT:
//         return '구매 적립';
//       case PointUsageType.MEMBERSHIP_DEPOSIT:
//         return '멤버십 등급 적립';
//       case PointUsageType.REGISTRATION_DEPOSIT:
//         return '회원가입 적립';
//       case PointUsageType.OFFICE_DEPOSIT:
//         return '관리자 적립';
//       case PointUsageType.WITHDRAW:
//         return '포인트 사용';
//       case PointUsageType.REFUND:
//         if (data.status === PointStatus.ACTIVE) {
//           return '환불';
//         } else if (data.status === PointStatus.USED) {
//           return '적립 회수';
//         } else {
//           // HACK: status=ACTIVE || status=USED 외의 경우 없어야함
//           return '환불';
//         }
//       case PointUsageType.EXPIRE:
//         return '소멸';
//     }
//   })();

//   const usageType = getUsageType + (isCanceled ? ' 취소' : '');

//   return (
//     <div className={`flex items-center justify-between border-b py-4`}>
//       <div className="flex flex-col gap-y-2">
//         {data.registerAt && (
//           <TextWinds type="content_body4" color="gray7">
//             {data.registerAt?.toString().slice(0, 10)}
//           </TextWinds>
//         )}
//         <div className={`text-lg font-semibold text-${textColor} `}>
//           {usageType}
//         </div>
//         {isEarn && (
//           <div className="flex gap-3">
//             <TextWinds type="content_body4" color="gray6">
//               유효기간
//             </TextWinds>
//             {data.expiryAt && (
//               <TextWinds type="content_body4" color="gray7">
//                 {data.expiryAt?.toString().slice(0, 10)} 까지
//               </TextWinds>
//             )}
//           </div>
//         )}
//       </div>
//       <div className={`flex-1 text-right ${isCanceled ? 'line-through' : ''}`}>
//         {/* 부호 : 적립일 경우 +, 사용일 경우 - */}
//         {/* amout의 절댓값에 천단위구분자(,) 추가 */}
//         <div className={`text-${textColor}`}>
//           {pointSign}
//           {pointAmount}점
//         </div>
//         {/* FIXME: 주문상세 페이지의 포인트 사용 내역과 정합성이 맞지 않아서 추후 배포 */}
//         {/* {data.relatedOrderId ? (
//           <div
//             onClick={() => {
//               navigate(`/mypage/purchase/detail/${data.relatedOrderId}`);
//             }}
//           >
//             {data.relatedOrderId}
//           </div>
//         ) : null} */}
//       </div>
//       {/* INFO: console 아닌 DOM에서 해당 데이터 확인할 수 있음 */}
//       <input hidden value={data.type} />
//       <input hidden value={data.usageType} />
//       <input hidden value={data.status} />
//       <input hidden value={data.amount} />
//     </div>
//   );
// };

export default PointItem;
